'use client'

import { createContext, useContext, useState } from 'react'

const LayoutControlContext = createContext(null)

export function LayoutControlProvider({ children }) {
  const [hideHeader, setHideHeader] = useState(false)
  const [hideFooter, setHideFooter] = useState(false)

  return (
    <LayoutControlContext.Provider
      value={{
        hideHeader,
        hideFooter,
        setHideHeader,
        setHideFooter,
      }}
    >
      {children}
    </LayoutControlContext.Provider>
  )
}

export function useLayoutControl() {
  const ctx = useContext(LayoutControlContext)

  if (!ctx) {
    throw new Error('useLayoutControl 必須在 LayoutControlProvider 裡使用')
  }

  return ctx
}
